// @flow

import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import swal from '@sweetalert/with-react';
import styled, { css } from 'styled-components';
import { clearfix, media } from 'styles/Mixins';
import { FlexColumn, FlexRow, Spacer } from 'styles/Layout';
import AuthenticationAction from 'actions/AuthenticationAction';
import HomieContext from 'HomieContext';
import ButtonDropDown from 'components/shared/ButtonDropDownComponent';
import { HeaderUtil } from 'utils/ExportCommon';
import DownArrow from 'AssetsRoot/images/homie_v3/down_arrow.svg.react';
import { CountryFlags, HeaderIcons } from 'utils/ExportCommon';
import { SET_URL_LANDING, DROPDOWN_ALIGNMENT } from 'utils/Constants';
import { isEmpty } from 'lodash';
import AppStore from 'stores/AppStore';
import { PRODUCT_SEEKER } from 'utils/Application';
import { goToNewOnBoarding, addHotjarScript } from 'utils/utils';

const Wrapper = styled.div`
  ${clearfix}
  display: ${props => (props.showNav ? 'flex' : 'none')};
  top: 0;
  margin: 0 auto;
  z-index: 100;
  min-height: 60px;
  background-color: #F0F0E8;
  border-bottom: 1px #F0F0E8 solid;
  width: 100%;
  align-items: center;
  position: fixed;
  ${media.md`
    max-width: 100%;
  `};
`;

const DownArrowIcon = styled(DownArrow)`
  display: block;
  height: 8px;
  width: 14px;
  margin-left: 10px;
  margin-top: 2px;
  ${media.md`
    display: none;
  `};
`;

const MexicoIcon = styled(CountryFlags.MexicoIcon)`
  display: block;
  height: 20px;
  width: 20px;
`;

const USAIcon = styled(CountryFlags.USAIcon)`
  display: block;
  height: 20px;
  width: 20px;
`;

const Container = styled(FlexRow)`
  width: 100%;
  height: 100%;
  flex-wrap: unset;
  justify-content: center;
  ${media.md`
    flex-wrap: wrap;
    max-width: 1024px;
    margin: auto;
  `};
`;

const Logo = styled(HeaderIcons.Logo)`
  object-fit: contain;
  height: 26px;
  width: 73px;
  vertical-align: middle;
  ${media.md`
    height: 32px;
    width: 94px;
  `};
`;

const IconContainer = styled.div`
  display: block;
  width: 15px;
  height: 17px;
  margin-right: 6px;
`;

const IconImage = styled.div`
  display: block;
  width: 15px;
  height: 15px;
  background-image: url(${({ coverImg }) => coverImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const FavoriteHeart = styled(HeaderIcons.FavoriteHeartSVG)`
  display: block;
  width: 15px;
  height: 15px;
`;

const Payments = styled(HeaderIcons.PaymentsSVG)`
  display: block;
  width: 15px;
  height: 15px;
`;

const ProfileImage = styled.div.attrs({
  style: ({ url }) => ({
    backgroundImage: `url('${url}')`
  })
})`
  display: block;
  height: 30px;
  width: 30px;
  background: 50% no-repeat;
  background-size: cover;
  border-radius: 50%;
  z-index: 4;
  pointer-events: none;
`;

const Calendar = styled(HeaderIcons.CalendarSVG)`
  display: block;
  width: 15px;
  height: 15px;
`;

const HomeMiniLogo = styled(HeaderIcons.HomeSVG)`
  display: block;
  width: 15px,
  height: 15px;
`;

const Option = styled(FlexRow)`
  min-height: 60px;
  min-width: 0;
  transition: background-color 0.2s linear;
  cursor: pointer;
  &:hover {
    background-color: #dcdeeb;
  }
  display: ${props => (props.hideInMobile ? 'none' : 'flex')};
  ${media.md`
    min-width: 120px;
    display: ${props => (props.hideInDesktop ? 'none' : 'flex')};
  `};
`;

const LangContainer = styled(FlexRow)`
  background: #babed7;
`;

const LangSelectedContainer = styled(FlexColumn)`
  position: relative;
  min-width: 0px;
  width: 50px;
  height: 60px;
  justify-content: center;
  align-items: center;
`;

const LangSelected = styled(FlexColumn)`
  align-items: center;
`;

const LangSelectedText = styled.span`
  color: #888;
  font-size: 12px;
  text-transform: uppercase;
`;

const LoginContainer = styled(FlexRow)`
  cursor: pointer;
  min-width: 0;
  display: none;
  ${media.md`
    display: flex;
  `};
`;

const MobileLoginContainer = styled(LoginContainer)`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  ${media.md`
    display: none;
  `};
`;

const ProfileImageLogin = styled(FlexRow)`
  position: relative;
  min-width: 0px;
  width: 74px;
  height: 60px;
  justify-content: center;
  align-items: center;
`;

const LoginDropDownOption = styled(Option)`
  min-height: 35px;
  width: 100%;
  min-width: 100% !important;
  align-items: center;
  font-size: 14px;
  padding: 9px 15px;
  color: #4a4a4a;
  font-size: 14px;
  line-height: 17px;
  user-select: none;
`;

const LangDropDownOption = styled(LoginDropDownOption)`
  color: #${({ isSelected }) => (isSelected ? 'FF0364' : '4a4a4a')};
  font-weight: ${({ isSelected }) => (isSelected ? '800' : '500')};
  pointer-events: ${({ isSelected }) => (isSelected ? 'none' : 'all')};
`;

const LogoOption = styled(Option)`
  min-width: 97px;
  margin: 0 3px;
  ${media.md`
    min-width: 124px;
    margin: 0 10px;
  `};
`;

const OnlyTextOption = styled(Option)`
  min-width: 120px;

  ${({ isVisible, hideInMobile, searchHome }) => css`
    display: ${!isVisible || hideInMobile ? 'none' : 'flex'};

    ${media.md`
      flex: 0 0 119px;
      display: ${isVisible ? 'flex' : 'none'};
      min-width: ${searchHome ? '200' : '140'}px;
    `};
  `}
`;

const OnlyTextOptionNewHome = styled(OnlyTextOption)`
  display: ${props =>
    !props.isVisible || props.hideInMobile || !props.isOwner ? 'none' : 'flex'};
  align-items: center;
  cursor: default;
  margin-right: 10px;
  &:hover {
    background: #f0f0e8;
  }
  ${media.md`
    min-width: 153px;
    display: ${props => (props.isVisible ? 'flex' : 'none')};
  `};
`;

const OptionText = styled.span`
  min-height: 17px;
`;

const StyledLink = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-decoration: none !important;
  padding: 0 12px;
  color: #5a2317;
  line-height: 17px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  ${media.md`
    font-size: 13px;
    padding: 0 15px;
  `};
`;

const NewHomeLink = styled(StyledLink)`
  height: 35px;
  border: 1px solid #4f5ea3;
  font-weight: bold;
  border-radius: 2px;
  font-size: 14px;
  padding: 0 12px;
  color: inherit;
  transition: all 0.2s linear;
  cursor: pointer;
  color: #4f5ea3;
  background: #fff;
  &:hover {
    color: #fff;
    background: #4f5ea3;
  }
`;

const HeaderSpacerLeft = styled(Spacer)`
  display: block;
  ${media.md`
    display: none;
  `}
`;

const HeaderSpacerRight = styled(Spacer)`
  display: none;
  ${media.md`
    display: block;
  `}
`;

const MobileMenuContainer = styled(FlexColumn)`
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 2;
  background: #fff;
  overflow: ${({ isMenuVisible }) => (isMenuVisible ? 'auto' : 'hidden')};
  max-height: ${({ isMenuVisible }) =>
    isMenuVisible ? 'calc(100% - 60px)' : '0'};
  transition: all 0.2s linear;
  ${media.md`
    display: none;
  `}
`;

const MobileMenuItem = styled(FlexColumn)`
  min-height: 62px;
  cursor: pointer;
  padding: 18px 20px;
  color: #4a4a4a;
  font-size: 18px;
  border-top: solid 1px #babed7;
`;

const MobileCloseMenu = styled(MobileMenuItem)`
  min-height: 86px;
  font-weight: bold;
  color: #278c7e;
  padding: 30px 20px;
`;

const Backdrop = styled(MobileMenuContainer)`
  height: calc(100vh - 60px);
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  z-index: 1;
  opacity: ${({ isMenuVisible }) => (isMenuVisible ? '1' : '0')};
  visibility: ${({ isMenuVisible }) => (isMenuVisible ? 'visible' : 'hidden')};
  transition: all 0.2s linear;
  ${media.md`
    display: none;
  `}
`;

const Divider = styled.div`
  height: 1px;
  background: #ccc;
  width: 100%;
`;

type PropsTypeAuth = {
  hideInDesktop?: boolean,
  hideInMobile?: boolean,
  isVisible: boolean,
  onClick: string => void,
  isOwner: boolean,
  location?: any,
  agency: any
};

const CheckDate = ({
  isVisible = true,
  hideInMobile = false,
  onClick,
  isOwner
}: PropsTypeAuth) => {
  if (!isVisible) return null;
  return (
    <Option hideInMobile={hideInMobile}>
      <StyledLink
        onClick={() =>
          onClick(isOwner ? '/propietario/citas' : '/inquilino/citas')
        }
      >
        <IconContainer>
          <Calendar />
        </IconContainer>
        <OptionText>Citas</OptionText>
      </StyledLink>
    </Option>
  );
};

const Favorite = ({
  isVisible = true,
  hideInMobile = false,
  hideInDesktop = false,
  onClick,
  agency = {}
}: PropsTypeAuth) => {
  if (!isVisible || (agency && agency.slug)) return null;
  return (
    <Option hideInMobile={hideInMobile} hideInDesktop={hideInDesktop}>
      <StyledLink onClick={() => onClick()}>
        <IconContainer>
          <FavoriteHeart />
        </IconContainer>
        <OptionText>Favoritos</OptionText>
      </StyledLink>
    </Option>
  );
};

const PaymentsOption = ({
  isVisible = true,
  hideInMobile,
  hideInDesktop,
  onClick
}: PropsTypeAuth) => {
  return (
    <Option hideInMobile={hideInMobile} hideInDesktop={hideInDesktop}>
      <StyledLink
        onClick={() =>
          onClick(
            isVisible
              ? '/inquilino/pagos/rentas'
              : '/inquilino/historial/rentas'
          )
        }
      >
        <IconContainer>
          <Payments />
        </IconContainer>
        <OptionText>Pagos</OptionText>
      </StyledLink>
    </Option>
  );
};

const Application = ({
  isVisible = true,
  hideInMobile,
  hideInDesktop,
  onClick
}: any) => {
  if (!isVisible) return null;
  return (
    <Option hideInMobile={hideInMobile} hideInDesktop={hideInDesktop}>
      <StyledLink onClick={() => onClick('/inquilino/aplicaciones')}>
        <IconContainer>
          <IconImage coverImg={HeaderUtil.appIcon} />
        </IconContainer>
        <OptionText>Aplicación</OptionText>
      </StyledLink>
    </Option>
  );
};

const HowItWork = (props: PropsTypeAuth) => {
  if (props.location.pathname === '/como-funciona-homie') return null;
  return (
    <OnlyTextOption isVisible={props.isVisible} hideInMobile>
      <StyledLink onClick={() => props.onClick('/como-funciona-homie')}>
        ¿Cómo funciona?
      </StyledLink>
    </OnlyTextOption>
  );
};

const Owner = ({ isVisible, onClick, location }: PropsTypeAuth) => {
  const urlHomes = '/inmuebles';
  const urlOwnerSignin = '/registro/propietario';

  if (location.pathname === urlOwnerSignin) return null;

  if (location.pathname === SET_URL_LANDING) {
    return (
      <OnlyTextOption isVisible={isVisible} hideInMobile searchHome>
        <StyledLink onClick={() => onClick(urlHomes)}>
          Estoy buscando un inmueble
        </StyledLink>
      </OnlyTextOption>
    );
  }

  return (
    <OnlyTextOption isVisible={isVisible} hideInMobile>
      <StyledLink onClick={() => onClick(SET_URL_LANDING)}>
        Soy propietario
      </StyledLink>
    </OnlyTextOption>
  );
};

const SignIn = (props: PropsTypeAuth) => (
  <OnlyTextOption isVisible={props.isVisible}>
    <StyledLink onClick={() => props.onClick('/autenticacion')}>
      Iniciar sesión
    </StyledLink>
  </OnlyTextOption>
);

const AddNewHome = ({
  isVisible,
  isOwner,
  onClick,
  agency,
  location,
  historyProp,
  isAdvisor
}: PropsTypeAuth) => {
  if (location.pathname === SET_URL_LANDING) return null;

  return (
    <OnlyTextOptionNewHome hideInMobile isVisible={isVisible} isOwner={isOwner}>
      <NewHomeLink
        onClick={() =>
          onClick(
            isAdvisor,
            isOwner,
            historyProp,
            '/propietario/registra-tu-inmueble',
            agency
              ? `/agencia/${agency.slug}/publicar/inmueble/nuevo`
              : '/propietario/registra-tu-inmueble'
          )
        }
      >
        Sube tu inmueble
      </NewHomeLink>
    </OnlyTextOptionNewHome>
  );
};

const DropDownLoginButton = ({ avatar }: any) => {
  return (
    <ProfileImageLogin>
      <ProfileImage url={avatar ? avatar : ''} />
      <DownArrowIcon />
    </ProfileImageLogin>
  );
};

const DropDownLangButton = ({ languageSelected }: any) => {
  return (
    <LangSelectedContainer>
      <LangSelected isVisible={languageSelected === 'es'}>
        <MexicoIcon />
        <LangSelectedText>Esp</LangSelectedText>
      </LangSelected>
      <LangSelected isVisible={languageSelected === 'en'}>
        <USAIcon />
        <LangSelectedText>Eng</LangSelectedText>
      </LangSelected>
    </LangSelectedContainer>
  );
};

const DropDownLangContainer = ({ languageSelected, changeLanguage }: any) => {
  return (
    <FlexColumn>
      <LangDropDownOption
        isSelected={languageSelected === 'es'}
        onClick={() => changeLanguage('es')}
      >
        Español
      </LangDropDownOption>
      <LangDropDownOption
        isSelected={languageSelected === 'en'}
        onClick={() => changeLanguage('en')}
      >
        English
      </LangDropDownOption>
    </FlexColumn>
  );
};

const DropDownLoginContainer = ({ onLogout }: any) => {
  return (
    <FlexColumn>
      <LoginDropDownOption onClick={onLogout}>
        Cerrar sesión
      </LoginDropDownOption>
    </FlexColumn>
  );
};

type PropsType = {
  showNav: boolean,
  history: any,
  location: any
};

const Header = (props: PropsType) => {
  const {
    currentUser,
    showLoadingProcessView,
    hideLoadingProcessView,
    languageSelected,
    changeLanguage
  } = useContext(HomieContext);
  const {
    authenticated,
    has_rents,
    isOwner,
    avatar,
    has_home_applications,
    has_rented_active_or_started_home,
    has_home_meetings,
    has_been_approved_in_any_rent,
    agency,
    source
  } = currentUser;
  const { history, showNav, location: routerLocation } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const currentAgency = agency;
  const isProductSeeker = source === PRODUCT_SEEKER;

  let windowMobile = window.matchMedia('(max-width: 991px)');
  windowMobile.addListener(viewport => {
    if (isMenuOpen && !viewport.matches) setIsMenuOpen(false);
  });

  useEffect(() => {
    AppStore.addUserListener(onChange);
    return () => {
      AppStore.removeUserListener(onChange);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    }, 250);
  }, [isMenuOpen]);

  const onChange = () => {
    hideLoadingProcessView();
    goToPage('/');
  };

  const goToPage = (basePath: string): void => {
    history.push(basePath);
  };

  const renderAdditionalLoginOption = () => {
    if (!isEmpty(currentUser.currentAdminUser)) {
      return (
        <LoginDropDownOption onClick={() => onBackLogin()}>
          Regresar a {currentUser.currentAdminUser.name}
        </LoginDropDownOption>
      );
    }
    return (
      <LoginDropDownOption
        onClick={() => (window.location.href = '/admin_logins/new')}
      >
        Iniciar sesión como otro usuario
      </LoginDropDownOption>
    );
  };

  const renderMobileAdditionalLoginOption = () => {
    if (!isEmpty(currentUser.currentAdminUser)) {
      return (
        <MobileMenuItem onClick={() => onBackLogin()}>
          Regresar a {currentUser.currentAdminUser.name}
        </MobileMenuItem>
      );
    }
    return (
      <MobileMenuItem
        onClick={() => (window.location.href = '/admin_logins/new')}
      >
        Iniciar sesión como otro usuario
      </MobileMenuItem>
    );
  };

  const renderAdminList = () => {
    if (isEmpty(currentUser.roles) || !currentUser.roles.includes('admin')) {
      if (!isEmpty(currentUser.currentAdminUser)) {
        return (
          <LoginDropDownOption onClick={() => onBackLogin()}>
            Regresar a {currentUser.currentAdminUser.name}
          </LoginDropDownOption>
        );
      }
      return null;
    }
    return (
      <FlexColumn>
        <LoginDropDownOption onClick={() => (window.location.href = '/admin')}>
          Panel admin
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/homes/unapproved')}
        >
          Inmuebles por aprobar
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/homes/new')}
        >
          Crear inmueble
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/promotion_codes')}
        >
          Cupones
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/leads_offline')}
        >
          Leads offline Rentas
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() =>
            (window.location.href = '/h/leads_offline_propietario')
          }
        >
          Leads offline Adq
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/h/financiamiento')}
        >
          Financiamiento
        </LoginDropDownOption>
        {/*<LoginDropDownOption
          onClick={() => (window.location.href = '/custom_zones')}
        >
          Zonas personalizadas
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/newsletters')}
        >
          Campañas
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/propietarios')}
        >
          Propietarios
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() =>
            (window.location.href = '/dashboard/propietarios#/asignar-tarjeta')
          }
        >
          Asignar tarjeta de sr pago
        </LoginDropDownOption>*/}
        {renderAdditionalLoginOption()}
        <Divider />
        <LoginDropDownOption
          onClick={() => (window.location.href = '/home_applications')}
        >
          Aplicaciones
        </LoginDropDownOption>
      </FlexColumn>
    );
  };

  const renderMobileAdminList = () => {
    if (isEmpty(currentUser.roles) || !currentUser.roles.includes('admin')) {
      if (!isEmpty(currentUser.currentAdminUser)) {
        return (
          <MobileMenuItem onClick={() => onBackLogin()}>
            Regresar a {currentUser.currentAdminUser.name}
          </MobileMenuItem>
        );
      }
      return null;
    }
    return (
      <FlexColumn>
        <MobileMenuItem onClick={() => (window.location.href = '/admin')}>
          Panel admin
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() => (window.location.href = '/homes/unapproved')}
        >
          Inmuebles por aprobar
        </MobileMenuItem>
        <MobileMenuItem onClick={() => (window.location.href = '/homes/new')}>
          Crear inmueble
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() => (window.location.href = '/promotion_codes')}
        >
          Cupones
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() => (window.location.href = '/leads_offline')}
        >
          Leads offline Rentas
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() =>
            (window.location.href = '/h/leads_offline_propietario')
          }
        >
          Leads offline Adq
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() => (window.location.href = '/h/financiamiento')}
        >
          Financiamiento
        </MobileMenuItem>
        {/*<MobileMenuItem
          onClick={() => (window.location.href = '/custom_zones')}
        >
          Zonas personalizadas
        </MobileMenuItem>
        <MobileMenuItem onClick={() => (window.location.href = '/newsletters')}>
          Campañas
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() => (window.location.href = '/propietarios')}
        >
          Propietarios
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() =>
            (window.location.href = '/dashboard/propietarios#/asignar-tarjeta')
          }
        >
          Asignar tarjeta de sr pago
        </MobileMenuItem>*/}
        {renderMobileAdditionalLoginOption()}
        <MobileMenuItem
          onClick={() => (window.location.href = '/home_applications')}
        >
          Aplicaciones Admin
        </MobileMenuItem>
      </FlexColumn>
    );
  };

  const renderExtraList = () => {
    if (
      isEmpty(currentUser.roles) ||
      (!currentUser.roles.includes('finance') &&
        !currentUser.roles.includes('super_admin'))
    )
      return null;
    return (
      <FlexColumn>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/rentas#/')}
        >
          Rentas
        </LoginDropDownOption>
        <LoginDropDownOption
          onClick={() => (window.location.href = '/rentas#/pagos-recibidos')}
        >
          Pagos recibidos
        </LoginDropDownOption>
      </FlexColumn>
    );
  };

  const renderMobileExtraList = () => {
    if (
      isEmpty(currentUser.roles) ||
      (!currentUser.roles.includes('finance') &&
        !currentUser.roles.includes('super_admin'))
    )
      return null;
    return (
      <FlexColumn>
        <MobileMenuItem onClick={() => (window.location.href = '/rentas#/')}>
          Rentas Admin
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() => (window.location.href = '/rentas#/pagos-recibidos')}
        >
          Pagos recibidos
        </MobileMenuItem>
      </FlexColumn>
    );
  };

  const onLogout = () => {
    if (isMenuOpen) setIsMenuOpen(false);
    showLoadingProcessView();
    AuthenticationAction.logout(response => {
      if (response && response.csrf) {
        if (currentAgency && currentAgency.id) {
          const agencyUrl = `/h/autenticacion/agencia/${currentAgency.slug}`;
          return (document.location.href = agencyUrl);
        }
        swal({
          className: 'logout',
          icon: '',
          title: 'Has salido del sistema',
          timer: 5000,
          button: {
            text: 'OK',
            value: true,
            visible: true,
            closeModal: true
          }
        });
      } else {
        location.reload();
      }
    });
  };

  const onBackLogin = () => {
    if (isMenuOpen) setIsMenuOpen(false);
    showLoadingProcessView();
    AuthenticationAction.backLogin(response => {
      goToPage('/');
      location.reload();
    });
  };

  const renderMyProprietorship = () => {
    if (!has_rented_active_or_started_home && !has_rents) return null;
    return (
      <Option hideInMobile>
        <StyledLink
          onClick={() =>
            goToPage(
              has_rented_active_or_started_home
                ? homesUrlByRole()
                : '/inquilino/pagos/rentas'
            )
          }
        >
          <IconContainer>
            <HomeMiniLogo />
          </IconContainer>
          <OptionText>
            {has_rented_active_or_started_home ? 'Mi inmueble' : 'Mi depa'}
          </OptionText>
        </StyledLink>
      </Option>
    );
  };

  const goToPageAndCloseMenu = (path: string) => {
    if (isMenuOpen) setIsMenuOpen(false);
    setTimeout(() => {
      goToPage(path);
    }, 250);
  };

  const handlePaymentsClick = (basePath: string): void => {
    const { source, roles } = currentUser || {};

    if (source !== 'homie_lite') {
      history.push(basePath);

      return;
    }

    const paymentPath = roles.includes('owner')
      ? '/owner/rents'
      : '/tenant/payments';

    window.location.href = `${process.env.HOMIE_LITE_URL}${paymentPath}`;
  };

  const renderHeaderOptions = () => {
    if (!authenticated) {
      return (
        <FlexRow>
          <Favorite
            agency={currentAgency}
            onClick={() => goToPageAndCloseMenu('/favoritos')}
          />
        </FlexRow>
      );
    }
    return (
      <FlexRow>
        {renderMyProprietorship()}
        <Favorite
          agency={currentAgency}
          onClick={() => goToPageAndCloseMenu('/favoritos')}
        />
        <Application
          isVisible={has_home_applications}
          hideInMobile
          onClick={goToPage}
        />

        {!isProductSeeker && (
          <CheckDate
            isOwner={isOwner}
            isVisible={isOwner || (!isOwner && has_home_meetings)}
            hideInMobile
            onClick={goToPage}
          />
        )}
        <PaymentsOption
          isVisible={has_been_approved_in_any_rent}
          hideInMobile
          onClick={handlePaymentsClick}
        />
      </FlexRow>
    );
  };

  const homesUrlByRole = () => {
    return currentAgency
      ? `/agencia/inmuebles/${currentAgency.slug}`
      : '/propietario/inmuebles';
  };

  return (
    <Wrapper showNav={showNav}>
      {addHotjarScript(routerLocation?.pathname)}
      <Container>
        <FlexRow>
          <LogoOption>
            <StyledLink
              disabled={currentAgency}
              onClick={() => !currentAgency && goToPageAndCloseMenu('/')}
            >
              <Logo />
            </StyledLink>
          </LogoOption>
        </FlexRow>
        <HeaderSpacerLeft isAuth={!authenticated} />
        {renderHeaderOptions()}
        <HeaderSpacerRight />
        <HowItWork
          isVisible={!authenticated}
          onClick={goToPage}
          location={routerLocation}
        />
        <Owner
          isVisible={!authenticated}
          onClick={goToPage}
          location={routerLocation}
        />
        <SignIn
          isVisible={!authenticated}
          onClick={() => goToPageAndCloseMenu('/autenticacion')}
        />
        <AddNewHome
          isVisible={authenticated}
          isOwner={isOwner}
          onClick={goToNewOnBoarding}
          agency={currentAgency}
          location={routerLocation}
          historyProp={history}
          isAdvisor={currentUser.isAdvisor}
        />
        <LoginContainer>
          <ButtonDropDown
            isOpenDropDown={false}
            BodyContainer={() => {
              return (
                <FlexColumn>
                  {renderAdminList()}
                  {renderExtraList()}
                  <DropDownLoginContainer
                    onLogout={onLogout}
                    onClick={goToPage}
                  />
                </FlexColumn>
              );
            }}
            ButtonContainer={() => {
              return <DropDownLoginButton avatar={avatar} />;
            }}
            alignment={DROPDOWN_ALIGNMENT.RIGHT}
            visible={authenticated}
          />
        </LoginContainer>
        <MobileLoginContainer
          isVisible={authenticated}
          alignItems="center"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <DropDownLoginButton avatar={avatar} />
        </MobileLoginContainer>
        {false && (
          <LangContainer>
            <ButtonDropDown
              isOpenDropDown={false}
              BodyContainer={() => {
                return (
                  <DropDownLangContainer
                    languageSelected={languageSelected}
                    changeLanguage={changeLanguage}
                  />
                );
              }}
              ButtonContainer={() => {
                return (
                  <DropDownLangButton languageSelected={languageSelected} />
                );
              }}
              alignment={DROPDOWN_ALIGNMENT.RIGHT}
            />
          </LangContainer>
        )}
      </Container>
      <MobileMenuContainer isMenuVisible={isMenuOpen}>
        <MobileMenuItem
          onClick={() => {
            goToPageAndCloseMenu(
              has_rented_active_or_started_home
                ? '/propietario/inmuebles'
                : '/inquilino/pagos/rentas'
            );
          }}
          isVisible={has_rented_active_or_started_home || has_rents}
        >
          Mi inmueble
        </MobileMenuItem>
        {!isProductSeeker && (
          <MobileMenuItem
            isVisible={isOwner || (!isOwner && has_home_meetings)}
            onClick={() =>
              goToPageAndCloseMenu(
                isOwner ? '/propietario/citas' : '/inquilino/citas'
              )
            }
          >
            Citas
          </MobileMenuItem>
        )}
        <MobileMenuItem
          isVisible={has_home_applications}
          onClick={() => goToPageAndCloseMenu('/inquilino/aplicaciones')}
        >
          Aplicaciones
        </MobileMenuItem>
        <MobileMenuItem
          isVisible={has_been_approved_in_any_rent}
          onClick={() => goToPageAndCloseMenu('/inquilino/pagos/rentas')}
        >
          Pagos
        </MobileMenuItem>
        <div>{renderMobileAdminList()}</div>
        <div>{renderMobileExtraList()}</div>
        <MobileMenuItem onClick={() => onLogout()}>
          Cerrar sesión
        </MobileMenuItem>
        <MobileCloseMenu onClick={() => setIsMenuOpen(false)}>
          Cerrar menú
        </MobileCloseMenu>
      </MobileMenuContainer>
      <Backdrop
        isMenuVisible={isMenuOpen}
        onClick={() => setIsMenuOpen(false)}
      />
    </Wrapper>
  );
};

export default withRouter(Header);
